<template>
	<div>
		<div v-for="e in eventsByDays" :key="e.id">
			<div class="date" v-if="e.isDate">{{ formatDate(e.date) }}</div>
			<PetEvent :event="e" @click="$emit('click', e)" v-else />
		</div>
	</div>
</template>

<script>
import PetEvent from '@/components/PetEvent'
import { isSameDay, format } from 'date-fns'
import { ru } from 'date-fns/locale'

export default {
	name: 'PetEventsGroup',
	components: {
		PetEvent,
	},
	props: {
		events: Array,
	},
	computed: {
		eventsByDays() {
			let lastDate = null
			let results = []

			this.events.forEach(e => {
				if (!isSameDay(new Date(lastDate), new Date(e.date))) {
					lastDate = e.date
					results.push({
						isDate: true,
						date: e.date,
					})
				}
				results.push(e)
			})

			return results
		},
	},
	mounted() {
		console.log(this.events)
	},
	methods: {
		formatDate(date) {
			return format(new Date(date), 'dd MMMM yyyy', { locale: ru })
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.date {
	margin: 5px 0;
	font-size: 12px;
	font-weight: bold;
	padding: 5px 10px;
	width: fit-content;
	border-radius: 30px;
	background: #000;
	color: #fff;
}
</style>
